// extracted by css-extract-rspack-plugin
export default {"root":"root-VrFkA1","formContainer":"formContainer-k6mEdj","star":"star-TODoxF","layer":"layer-dxLHie","under":"under-DitlQq layer-dxLHie","over":"over-RzMvcr layer-dxLHie"};